import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ErrorHandler, Product } from '../../utils/types';

import avoidDeactivationDataModalQuery, {
	type avoidDeactivationDataModalQuery as AvoidDeactivationDataModalQuery,
} from './__generated__/avoidDeactivationDataModalQuery.graphql';

/**
 * Entry point parameters for the auto-upgrade avoid deactivation modal
 */
export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
	onError?: ErrorHandler;
	product: Product;
	touchpointId: string;
};

/**
 * Entry point for the auto-upgrade avoid deactivation modal
 */

export const autoUpgradeAvoidDeactivationEntrypoint: EntryPoint<
	EntryPointComponent<
		{ avoidDeactivation: AvoidDeactivationDataModalQuery },
		Record<string, never>,
		{ cloudId: string; hamsProductKey: string; onClose: () => void },
		{ onError?: ErrorHandler; product: Product; touchpointId: string }
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_avoid-deactivation-data-modal" */ './avoid-deactivation-data-modal'
			),
		{ moduleId: 'avoid-deactivation-data-modal' },
	),
	getPreloadProps: ({
		cloudId,
		hamsProductKey,
		touchpointId,
		onError,
		product,
	}: EntryPointParams) => ({
		entryPoints: {},
		extraProps: { touchpointId, onError, product },
		queries: {
			avoidDeactivation: {
				parameters: avoidDeactivationDataModalQuery,
				variables: { cloudId, hamsProductKey },
			},
		},
	}),
});
